import styled from 'styled-components';

export const Form = styled.form`
  display: block;
`;

export default Form;
